import {React, useContext, useMemo, Link} from 'external/react'
import {clsx} from 'external/material'
import {viewerGuard, pdfPreviewLink} from 'helpers/url'
import {IconLink} from '../icon'
import Unit from './unit'
import Container from './Container'
import ScheduleLesson from '../schedule-lesson'
import DreyfousLabsLink from './DreyfousLabsLink'
import  './units.styl'

import { TeacherContext } from 'teacher/context'

export default function Units () {

    const context = useContext(TeacherContext)
    const {course, unit, languageId, action, profile} = context

    const isDreyfous = useMemo(() => profile.domain == 'dreyfous' , [profile.domain])

    const [courseInfo, ...units] = context.units
    const unitId = `${course}U${unit}`
    const backPath = context.link({course: undefined, unit: undefined}, context.match.path, {preserveQuery: true})
  
    const overviewLabel = /^C8/.test(course) ? 'dgenius_overview_label' : 'overview_label'

    return (
      <div className="units">
        { courseInfo && (
          <div className="course-info">
            <Link className = "back" to={backPath} />
            <label>{courseInfo.name}</label>
            <div className={clsx('overview-link', {inactive: !courseInfo.hasOverview})}>
                <IconLink
                  {...viewerGuard({href: pdfPreviewLink('download', 'overview', languageId, course), target: "blank"})}
                  icon="overview"
                  label={overviewLabel}
                />
              </div>
              <div className={clsx('guide-link', {inactive: !courseInfo.hasGuide})}>
                <IconLink
                  {...viewerGuard({href:pdfPreviewLink('download', 'guide', languageId, course), target:"blank"})}
                  icon="guide"
                  label="guide_label"
                />
              </div>
               <div className={clsx('student-workbook-link', {inactive: !courseInfo.hasStudentWorkbook})}>
                <IconLink
                  {...viewerGuard({href:pdfPreviewLink('download', 'guide', 'student_workbook', languageId, course), target:"blank"})}
                  icon="workbook"
                  label="student_workbook_label"
                />
              </div>
               <div className={clsx('workbook-link', {inactive: !courseInfo.hasWorkbook})}>
                <IconLink
                  {...viewerGuard({href:pdfPreviewLink('download', 'workbook', languageId, course), target:"blank"})}
                  icon="workbook"
                  label="workbook_label"
                />
              </div>
               <div className={clsx('coursemap-link', {inactive: !courseInfo.hasCoursemap})}>
                <IconLink
                  {...viewerGuard({href:pdfPreviewLink('download', 'guide', 'coursemap', languageId, course), target:"blank"})}
                  icon="guide"
                  label="coursemap_label"
                />
              </div>
               <div className={clsx('didactical-resource-link', {inactive: !courseInfo.hasDidacticalResource})}>
                <IconLink
                  {...viewerGuard({href:pdfPreviewLink('download', 'guide', 'didactical_resource', languageId, course), target:"blank"})}
                  icon="summary"
                  label="didactical_resource_label"
                />
              </div>
              <div className={clsx('dreyfouslabs-link', {inactive: !/^C6/.test(course) })}>
                <DreyfousLabsLink />
              </div>
          </div>
        )}
        { ['schedule', 'posts'].indexOf(action) >= 0 && (<ScheduleLesson
          selectedGroup={{}}
          activeTab='groups'
          />)}
        <Container>
          {units && units.map(unit => (<Unit key={unit.id} active={unit.id == unitId} {...unit} />))}
        </Container>
      </div>
    )
  }
